import { useState } from 'react';
import { IPartnerClientCreated } from '../../services/partner.service';
import './autoparkApiTokens.css';

interface SecretRevealModalProps {
  created: IPartnerClientCreated | null;
  onClose: () => void;
}

// Shows client_id + client_secret exactly once. The backend never returns the secret again, so this
// modal is the only place it is ever rendered; there is no backdrop-click close to avoid an
// accidental dismissal before the user copied it.
function SecretRevealModal({ created, onClose }: SecretRevealModalProps) {
  const [copied, setCopied] = useState<'id' | 'secret' | null>(null);

  if (!created) return null;

  const copy = async (what: 'id' | 'secret', value: string) => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(what);
      setTimeout(() => setCopied((c) => (c === what ? null : c)), 1500);
    } catch {
      // Clipboard API unavailable (insecure context) — the value is selectable, the user can copy manually.
    }
  };

  return (
    <div className="api-tokens-modal-overlay">
      <div className="api-tokens-modal api-tokens-modal--wide">
        <h2 className="api-tokens-modal__title">Учётные данные «{created.name}» созданы</h2>

        <div className="api-tokens-secret-warning">
          Секрет показывается <strong>только один раз</strong>. Скопируйте и сохраните его сейчас — после закрытия окна
          получить его снова невозможно. Если секрет потерян, создайте новые учётные данные.
        </div>

        <div className="api-tokens-secret-row">
          <span className="api-tokens-secret-row__label">client_id</span>
          <code className="api-tokens-secret-row__value">{created.client_id}</code>
          <button type="button" className="api-tokens-copy-btn" onClick={() => copy('id', created.client_id)}>
            {copied === 'id' ? 'Скопировано' : 'Копировать'}
          </button>
        </div>

        <div className="api-tokens-secret-row">
          <span className="api-tokens-secret-row__label">client_secret</span>
          <code className="api-tokens-secret-row__value">{created.client_secret}</code>
          <button type="button" className="api-tokens-copy-btn" onClick={() => copy('secret', created.client_secret)}>
            {copied === 'secret' ? 'Скопировано' : 'Копировать'}
          </button>
        </div>

        <div className="api-tokens-modal__actions">
          <button type="button" className="api-tokens-btn api-tokens-btn--primary" onClick={onClose}>
            Я сохранил секрет, закрыть
          </button>
        </div>
      </div>
    </div>
  );
}

export default SecretRevealModal;
